import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-snowlogs',
  templateUrl: './snowlogs.component.html',
  styleUrls: ['./snowlogs.component.css']
})
export class SnowlogsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
